/*
 * Copyright (c) 2023. Haodong JU
 */

import { addDoc, collection, doc, query, setDoc, where } from 'firebase/firestore'
import { FireBaseStore } from '@/model/firebase/google-fire-base'
import { getCurrentStoreId, getCurrentUserId } from '@/model/dataLayer/api/SaaS/user'
import { docContentOf, resultOfId } from '@/model/firebase/queryUtils'
import { currentTimestampFirebase } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage'
import IKUtils from 'innerken-js-utils'
import { hillo } from 'hillo'

const userServiceRight = 'userServiceRight'
const userConsumeRecord = 'userConsumeRecord'
const userGoodsAddressInfo = 'userGoodsAddressInfo'
const userBillsAddressInfo = 'userBillsAddressInfo'

export async function addServicePointForUser (productId, orderId) {
  const userId = getCurrentUserId()
  return await addDoc(collection(FireBaseStore, userServiceRight), {
    userId,
    productId,
    orderId,
    createTimestamp: currentTimestampFirebase()
  })
}

export async function getUserServiceRight () {
  const collectionRef = collection(FireBaseStore, userServiceRight)
  const res = query(collectionRef, where('userId', '==', getCurrentUserId()))
  return await resultOfId(res)
}

export async function addUserConsumeRecord (serviceId) {
  const userId = getCurrentUserId()
  return await addDoc(doc(FireBaseStore, userConsumeRecord, serviceId), {
    userId,
    serviceId,
    usageTimestamp: currentTimestampFirebase()

  })
}

export async function setDeliveryAddressInfo (deliveryAddressInfo) {
  return await setDoc(doc(FireBaseStore, userGoodsAddressInfo, getCurrentUserId()), {
    userId: getCurrentUserId(), deliveryAddressInfo: IKUtils.extend(defaultAddressInfo, deliveryAddressInfo)
  })
}

export async function setBillsAddressInfo (billsAddressInfo) {
  return await setDoc(doc(FireBaseStore, userBillsAddressInfo, getCurrentUserId()), {
    userId: getCurrentUserId(),
    billsAddressInfo: IKUtils.extend(defaultAddressInfo, billsAddressInfo)
  })
}
const defaultAddressInfo = {
  userName: '',
  address1: '',
  address2: '',
  city: '',
  postcode: '',
  phone: ''
}
export async function getDeliveryAddressInfo () {
  return (await docContentOf(doc(FireBaseStore, userGoodsAddressInfo, getCurrentUserId())))?.deliveryAddressInfo ?? IKUtils.extend(defaultAddressInfo)
}

export async function getBillsAddressInfo () {
  return (await docContentOf(doc(FireBaseStore, userBillsAddressInfo, getCurrentUserId())))?.deliveryAddressInfo ?? IKUtils.extend(defaultAddressInfo)
}

export async function uploadImage (file) {
  const storage = getStorage()
  const storageRef = ref(storage, 'images' + getCurrentUserId())
  return await uploadBytes(storageRef, file)
}

export async function downloadImage () {
  const storage = getStorage()
  const storageRef = ref(storage, 'images' + getCurrentUserId())
  try {
    return await getDownloadURL(storageRef)
  } catch (e) {
    console.log(e, 'e')
    return null
  }
}

export const baseUrl = 'https://cloud-v2.aaden.io/'

export async function getDeviceSubscriptionList () {
  return await hillo.get(baseUrl + 'subscriptions/by-device/' + await getCurrentStoreId())
}

export async function getUserSubscriptionList () {
  return await hillo.get(baseUrl + 'subscriptions/portalLink/' + getCurrentUserId())
}

export async function cancelSubscription (subscriptionId) {
  return await hillo.jsonPost(baseUrl + 'subscriptions/cancel/' + subscriptionId)
}

export async function getDeviceBills () {
  return (await hillo.get(baseUrl + 'subscriptions/invoices/' + await getCurrentStoreId()))
}
